export const NotImplemented = () =>
  console.error("Context Method not implemented");

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const Noop = () => {};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const AsyncNoop = async () => {};
